<template>
<div>
    <Navigator/>
    <Articles/>
    <Footer/>

    
</div>
</template>

<script>
import Navigator from '@/components/Navigator'
import Footer from '@/components/Footer'
import Articles from '@/components/Articles'

export default {
    name: "Landing",
    components: {
        Navigator,
        Articles,
        Footer
    }
}
</script>
